import { isMacOs, isWindows } from "react-device-detect";

export async function openSystemPreferences(pane, section) {
  if (isMacOs) {
    await window.Main.shellOpenExternal(`x-apple.systempreferences:com.apple.preference.${pane}${section ? `?${section}` : ''}`);
  } else if (isWindows) {
    await window.Main.shellOpenExternal(`ms-settings:${pane}`);
  }
}